module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0004.jpg?v=a8c8a626";